import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { notification, Button, Row, Image, Col, Table, Modal } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ASSETS_URL, deletePhoto, getPhotos } from "../../services/api";
import { DeleteOutlined, FileAddOutlined } from '@ant-design/icons';
import PageTitle from "../../components/page-title";

const Photos = () => {
    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const {data} = useQuery({ queryKey: ['photos'], queryFn: getPhotos });
    const {mutate: mutateDeletePhoto} = useMutation(deletePhoto)
    const [isOpenDeletePhotoModal, setisOpenDeletePhotoModal] = useState({open: false, id: 0});
  
    const handleDelete = () => {
      mutateDeletePhoto({id: isOpenDeletePhotoModal.id}, {
        onSuccess() {
          queryClient.invalidateQueries(['photos']);
          setisOpenDeletePhotoModal({open: false, id: 0});
          ntf.success({
            message: `Success`,
            description: "Blog is deleted with success!",
            placement: "bottomLeft",
          });
        },
        onError() {
          ntf.error({
            message: `Error`,
            description: "Something gonne wrong!",
            placement: "bottomLeft",
          });
        },
      })
    }
  
    const columns: any = [
      {
        title: 'Photo Id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Photo',
        dataIndex: 'name',
        key: 'photo',
        render: (key: string, record: any) => <Image width={64} src={`${ASSETS_URL}photos/uploads/mobile/${record.name}`} />
      },
      {
        title: 'Date Added',
        dataIndex: 'date',
        key: 'date'
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: 'Delete',
        dataIndex: 'delete',
        key: 'delete',
        align: 'center',
        width: '50px',
        render: (id: any, record: any) => <Button icon={<DeleteOutlined />} danger onClick={() => setisOpenDeletePhotoModal({open: true, id: record.id})} />
      },
    ];
    
  
    return (
      <Row justify="center">
        {contextHolder}
        <PageTitle text={`Photos`} />
        <Col span={20}>
            <Row>
                <Col>
                    <Link to="/photos/create">
                        <Button type="primary" icon={<FileAddOutlined />}>Upload Photos</Button>
                    </Link>
                </Col>
            </Row>
        </Col>
        <Col span={20}>
          <Table dataSource={data} columns={columns} />;
        </Col>
        <Modal title="Delete Blog?" open={isOpenDeletePhotoModal.open} onOk={() => handleDelete()} onCancel={() => setisOpenDeletePhotoModal({open: false, id: 0})}>
          Do you really want to delete it?
        </Modal>
      </Row>
    )
  }
  
  export default Photos